import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, CustomInput } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import withFirebase from 'view/FirebaseAnalytics/withFirebase';
import withStep from './StepContext/withStep';

class StepFastPreparationDays extends React.Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        fastPreparationDays: PropTypes.number.isRequired,
        handleInputChange: PropTypes.func.isRequired,
        changeNextBtnState: PropTypes.func.isRequired,
        trackFirebaseEvent: PropTypes.func.isRequired,
    };

    componentDidMount() {
        this.props.changeNextBtnState(!this.props.fastPreparationDays);
        this.props.trackFirebaseEvent('screen_view ', {
            firebase_screen: 'diet-fasting_preparation',
        });
    }

    componentDidUpdate() {
        this.props.changeNextBtnState(!this.props.fastPreparationDays);
    }

    render() {
        return (
            <div className="full-screen3">
                <div className="mb-auto w-100">
                    <Label>
                        {this.props.t('diet-settings/fast-days/title')}
                    </Label>

                    <FormGroup tag="fieldset">
                        <div className="card">
                            <h2 className="text-center">
                                {this.props.t(
                                    'diet-settings/fast-days/fast-preparation/title'
                                )}
                            </h2>
                            <h3 className="text-center">
                                <span className="big-number">
                                    {this.props.fastPreparationDays}
                                </span>{' '}
                                {this.props.t('diet-settings/fast-days/days')}
                            </h3>

                            <CustomInput
                                type="range"
                                name="fastPreparationDays"
                                id="fastPreparationDays"
                                min="1"
                                max="14"
                                step="1"
                                style={{
                                    '--value': `${(this.props
                                        .fastPreparationDays /
                                        14) *
                                        100 -
                                        2}%`,
                                }}
                                value={this.props.fastPreparationDays}
                                onChange={this.props.handleInputChange}
                            />

                            {this.props.fastPreparationDays < 3 && (
                                <p className="small mt-3 mb-0 text-center">
                                    {this.props.t(
                                        'diet-settings/fast-days/fast-preparation/info'
                                    )}
                                </p>
                            )}
                        </div>
                    </FormGroup>
                </div>
            </div>
        );
    }
}

export default withFirebase(withStep(withLocale(StepFastPreparationDays)));
